import { toUTCDateOnly } from "@common/helpers/date";

/**
 * The calendar day a schedule on an invoice runs from: the invoice date, or
 * for integration invoices that carry none, the UTC day it was created.
 * Shared so the modal previews the day the backend posts.
 */
export function resolveInvoiceSourceDate(invoice: {
    invoiceDate: string | null;
    createdAt: Date | string;
}): string {
    return invoice.invoiceDate ?? toUTCDateOnly(invoice.createdAt);
}
